import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { RouterModule } from '@angular/router';
import { FuseConfirmDialogModule } from 'app/projects/fuse/src/lib/components/confirm-dialog/confirm-dialog.module';
import { MaxBrainSharedModule } from 'app/projects/shared/src/lib/shared.module';
import { NgChartsModule } from 'ng2-charts';
import { NgxCleaveDirectiveModule } from 'ngx-cleave-directive';
import { MaxBrainAllModulesModule } from '../all-modules/all-modules.module';
import { CertificateRecordModule } from '../certificate-record/certificate-record.module';
import { CertificationModule } from '../certifications/certification.module';
import { TagMultiSelectModule } from '../tag/components/multi-select/multi-select.module';
import { TagModule } from '../tag/tag.module';
import { ModuleCardsListComponent } from './components/cards/cards.component';
import { CancelCourseDialogComponent } from './components/dialogs/cancel-course/cancel-course-dialog.component';
import { ArchiveProgramDialogComponent } from './components/dialogs/archive-program-dialog/archive-program-dialog.component';
import { ChangeProgramCompletionDialogComponent } from './components/dialogs/change-program-completion-dialog/change-program-completion-dialog.component';
import { ContentStructureDialogComponent } from './components/dialogs/content-structure/content-structure.component';
import { CopyToExistingDialogComponent } from './components/dialogs/copy-to-existing/copy-to-existing-module-dialog.component';
import { CopyToNewDialogComponent } from './components/dialogs/copy-to-new/copy-to-new-module-dialog.component';
import { EditRelevantExecutionsDateRangeDialogComponent } from './components/dialogs/edit-relevant-executions-date-range/edit-relevant-executions-date-range-dialog.component';
import { NotificationPreviewDialogComponent } from './components/dialogs/notification-preview-dialog/notification-preview-dialog.component';
import { NumberOfAttemptsDialogComponent } from './components/dialogs/number-of-attempts/number-of-attempts-dialog.component';
import { ParticipantsProgressDialogComponent } from './components/dialogs/participants-progress/participants-progress.component';
import { PublishAllSectionsDialogComponent } from './components/dialogs/publish-all-sections/publish-all-sections-dialog.component';
import { TakeOverUsersToModulesDialogComponent } from './components/dialogs/take-over-users-to-modules/take-over-users-to-modules.component';
import { LearnerProfileComponent } from './components/learner-profile/learner-profile.component';
import { AllowedModulesListComponent } from './components/list/allowed-modules-list/allowed-modules-list.component';
import { ModuleApiService } from './services/module.api-service';
import { ModuleService } from './services/module.service';

@NgModule({
    imports: [
        RouterModule,
        MaxBrainSharedModule,

        MatCheckboxModule,
        MatMenuModule,
        MatTableModule,
        MatFormFieldModule,
        MatListModule,
        MatCardModule,
        MatSortModule,
        MatPaginatorModule,
        MatButtonToggleModule,
        MatDatepickerModule,
        MatChipsModule,
        MatIconModule,
        MatToolbarModule,
        MatSelectModule,
        MatAutocompleteModule,
        MatButtonModule,
        MatRadioModule,
        MatExpansionModule,
        MatProgressBarModule,
        MatInputModule,
        MatProgressSpinnerModule,
        MatSlideToggleModule,
        MatStepperModule,
        MaxBrainAllModulesModule,
        MatTreeModule,
        MatTooltipModule,

        FormsModule,
        ReactiveFormsModule,
        FuseConfirmDialogModule,

        TagModule,
        TagMultiSelectModule,
        NgxCleaveDirectiveModule,
        NgChartsModule,
        MatTabsModule,
        CertificateRecordModule,
        CertificationModule,
    ],
    declarations: [
        ModuleCardsListComponent,
        TakeOverUsersToModulesDialogComponent,
        PublishAllSectionsDialogComponent,
        ContentStructureDialogComponent,
        ParticipantsProgressDialogComponent,
        CopyToExistingDialogComponent,
        AllowedModulesListComponent,
        CopyToNewDialogComponent,
        ChangeProgramCompletionDialogComponent,
        ArchiveProgramDialogComponent,
        CancelCourseDialogComponent,
        EditRelevantExecutionsDateRangeDialogComponent,
        LearnerProfileComponent,
        NumberOfAttemptsDialogComponent,
        NotificationPreviewDialogComponent,
    ],
    exports: [
        ModuleCardsListComponent,
        TakeOverUsersToModulesDialogComponent,
        PublishAllSectionsDialogComponent,
        ContentStructureDialogComponent,
        ParticipantsProgressDialogComponent,
        CopyToExistingDialogComponent,
        CopyToNewDialogComponent,
        ChangeProgramCompletionDialogComponent,
        ArchiveProgramDialogComponent,
        CancelCourseDialogComponent,
        EditRelevantExecutionsDateRangeDialogComponent,
        LearnerProfileComponent,
        NumberOfAttemptsDialogComponent,
        NotificationPreviewDialogComponent,
    ],
    providers: [ModuleService],
})
export class MaxBrainModuleModule {
    static forRoot(): ModuleWithProviders<MaxBrainModuleModule> {
        return {
            ngModule: MaxBrainModuleModule,
            providers: [ModuleApiService],
        };
    }
}
